import { Label } from "semantic-ui-react"
import Price from "components/Price/Price"
import React from "react"
import shop from "shop/shop"


const ProductPrice = ( { product, className = "pb4 pt2 relative lh-solid" } ) => {
  return <div className={`ProductPrice ${className}`}>
      <div className="flex flex-row pb2">
      {product.pinfos.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.pinfos.gc_rabatt} %</Label>}
      {/*product.isSale.value.value == "Ja" && <Label className={"salePercent"} color="red">{product.salePercent}</Label>*/}
      {product.extras && product.extras.neuheit && product.extras.neuheit && product.extras.neuheit.value.value == "Ja"  && <a className="labelNeu3">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
      {product.isSale && <a className="">&nbsp;</a> }
      {product.isSale && <a className="labelNeu3">&nbsp;&nbsp;{product.extras.rabatt.value.value}%&nbsp;Rabatt&nbsp;</a>}
      {product.extras && product.extras.premium && product.extras.premium && product.extras.premium.value.value == "Ja"  && <a className="">&nbsp;</a> }
      {product.extras && product.extras.premium && product.extras.premium && product.extras.premium.value.value == "Ja"  && <a className="labelNeu3">&nbsp;&nbsp;{translate("Premium")}&nbsp;&nbsp;</a>}
{console.log("product",product)}
       </div>
    {product.isSale && shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
    <div className="price ">
      {/*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*/}
      <div className="f4 red b"><Price>{product.price}</Price> {/*<span className="f5 black-60 fw4 pb1 strike "><Price>{product.pinfos.brutto}</Price></span>*/}</div>
      <div className=" black-70 f6 fw2 lh-solid">{translate("PRICE_PREFIX")} {product.baseUnitDisplayName || product.extras.veextrainfo || translate( "Stück" )}</div>
    </div>}
    {!product.isSale && shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
    <div className="price lh-solid">
      <div className="f3  b"><Price>{product.price}</Price> {product.salePercent &&
      <span className={"black-60 f5 fw4"}>(<Price>{product.originalPrice}</Price> {translate("abzgl.")} {product.salePercent} {translate("Rabatt")})</span>}
      </div>
      <div className=" black-70 f6 fw2 lh-solid">{translate("PRICE_PREFIX")} {product.baseUnitDisplayName ||  product.extras.veextrainfo || translate( "Stück" )}</div>
    </div>}

    {/*{(product.isSale.value.value == "Ja" && product.quantities.length > 1) &&*/}
    {/*<div className="price ">*/}
    {/*  /!*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*!/*/}
    {/*  <div className="f5 black-60 strike"><Price>{product.price * product.unit_multi}</Price></div>*/}
    {/*  <div className="f4 red b"><Price>{product.price}</Price></div>*/}
    {/*</div>}*/}
    {/*{(!product.isSale.value.value == "Ja" && product.quantities.length > 1) &&*/}
    {/*<div className="price color lh-solid pt2 ">*/}
    {/*  <div className="f3  b"><Price>{product.price * product.unit_multi}</Price></div>*/}
    {/*  <div className=" black-70 f6 fw2 lh-solid">{translate( "VE Preis" )} ({product.unit_multi} {translate( "Stück" )})</div>*/}
    {/*</div>}*/}
  </div>
}

export default ProductPrice


// WEBPACK FOOTER //
// ./src/theme/braunco/components/Product/ProductPrice.js